var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("chart-by-month", {
    attrs: {
      resultSetByMonth: _vm.resultSetByMonth,
      chartDataMonth: _vm.chartDataMonthNCDJ,
      chartDataAverage: _vm.chartDataAverageNCDJ,
      graph: _vm.graph,
      displayed: _vm.displayed
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }